module.exports = __webpack_public_path__ + "static/media/20210403_215155_301_IMG_0063.141b758f.jpg";